export const PRICE_INDEX_LIST_PAGE_UUID = 'f35e2fc0-2ce2-4b05-af46-ab2251edc520'

export const PRICE_INDEX_CATEGORY_PAGE_UUID =
  '7b5c4742-0583-4f20-b8e2-cb9e66a7f36c'

export const PRICE_INDEX_ACTION_UUID = '1c3fdc61-0e9e-4f7b-a3c8-327655110692'
